import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import ContentPricing from './ContentPricing';

export type ContentPricingContainerProps = {};

export function ContentPricingContainer(_props: ContentPricingContainerProps) {
  const dispatch = useDispatch();
  const user = useSelector(selectors.base.$user);

  const callbacks = useMemo(
    () => ({
      onPlanSelect: (planId: string) => {
        dispatch({
          type: 'PURCHASE',
          verb: 'plan',
          id: planId,
        });
      },
    }),
    []
  );

  return <ContentPricing user={user} onPlanSelect={callbacks.onPlanSelect} />;
}

export default ContentPricingContainer;
